module.exports = __webpack_public_path__ + "img/img_12.a5ef7c85.png";